import { render, staticRenderFns } from "./v-input-select.vue?vue&type=template&id=3112fe88&scoped=true&"
import script from "./v-input-select.vue?vue&type=script&lang=js&"
export * from "./v-input-select.vue?vue&type=script&lang=js&"
import style0 from "./v-input-select.vue?vue&type=style&index=0&id=3112fe88&lang=scss&scoped=true&"
import style1 from "./v-input-select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112fe88",
  null
  
)

export default component.exports